import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "~/lib/utils";
import type { CardVariant } from "./_types";
import { CardContext } from "./card.context";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  variant: CardVariant;
  children: Readonly<ReactNode>;
  className?: string;
}

export default function CardRoot({
  children,
  variant,
  className,
  ...props
}: CardProps) {


  return (
    <CardContext.Provider value={{ variant }}>
      <div className={cn(variant == "faq" ? "faq-card" : "card", className)} {...props}>{children}</div>
    </CardContext.Provider>
  )



}
